// extracted by mini-css-extract-plugin
export var cell = "_6y-4";
export var headerCell = "_6y-2";
export var rowHeader = "_6y-3";
export var table = "_6y-1";
export var tableContainer = "_6y-0";